/**
 * @generated SignedSource<<81c74c3eeb4c849b0f17a349c8147c05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SourceAdminMenuDelMutation$variables = {
  id: string;
};
export type SourceAdminMenuDelMutation$data = {
  readonly deleteGeneratedSources: {
    readonly copySource: boolean | null;
  } | null;
};
export type SourceAdminMenuDelMutation = {
  response: SourceAdminMenuDelMutation$data;
  variables: SourceAdminMenuDelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "copySource",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceAdminMenuDelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "deleteGeneratedSources",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SourceAdminMenuDelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "deleteGeneratedSources",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6dcdab9da47924c5ed5609d0a2335bc2",
    "id": null,
    "metadata": {},
    "name": "SourceAdminMenuDelMutation",
    "operationKind": "mutation",
    "text": "mutation SourceAdminMenuDelMutation(\n  $id: ID!\n) {\n  deleteGeneratedSources(id: $id) {\n    copySource\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2314a5d342cf42824a6993dceb6fe792";

export default node;
